module.exports = __webpack_public_path__ + "assets/img/icon-804.84c66de3.png";